import React from "react";
import { AutoTextTranslate, isEmptyObject } from "../../Tools/Tools";
import { IconButton } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";
import CloseIcon from "@mui/icons-material/Close";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import cn from "classnames";
import { useAtomValue } from "jotai";
import { currentTheme, sectionListAtom, smetaStore } from "../../../../atoms";

const styles = (theme) => ({
  popper: {
    width: "fit-content",
  },
});

const PopperMy = function (props) {
  return <Popper {...props} style={styles.popper} placement="bottom-start" />;
};

export default function SectionSearch(props) {
  const theme = useAtomValue(currentTheme);
  const [SearhJson, setSearhJson] = React.useState([]);
  const [value, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");
  const sideBarData = smetaStore.get(sectionListAtom);

  React.useEffect(() => {
    if (SearhJson.length === 0) setSearhJson(StasFilter());
    if (inputValue === "") setSearhJson([]);
  }, [inputValue]);

  function StasFilter() {
    if (!isEmptyObject(sideBarData)) {
      let valueany,
        ra = [],
        subElem;
      let valueReportAny, subItems, Enabled, SubElemItem, Section;
      for (const [key, value] of Object.entries(sideBarData)) {
        valueany = value;
        Section = {
          ID: valueany.ID,
          CLSID: valueany.CLSID,
          Name: valueany.Name,
        };
        ra.push(
          Object.assign({}, Section, {
            Who: "Section",
            FullName: valueany.Name,
            PrevName: "",
            AfterName: "",
          }),
        );
        if (valueany.Reports !== undefined) {
          //Reports
          for (const [key, valueReport] of Object.entries(valueany.Reports)) {
            valueReportAny = valueReport;
            Enabled = valueReportAny.Enabled === undefined ? true : valueReportAny.Enabled;
            if (Enabled) ra.push(SubFliter(valueReport, valueany.Name, "Report", Section));
            if (valueReportAny.items !== undefined) {
              for (const [key, valueReportItems] of Object.entries(valueReportAny.items)) {
                subItems = SubFliter(valueReportItems, valueany.Name + "/" + valueReportAny.Name, "Report", Section);
                if (subItems !== undefined && !Enabled) {
                  ra.push(subItems);
                }
              }
            }
            subElem = undefined;
            subItems = undefined;
          }
        }
        if (valueany.Documents !== undefined) {
          for (const [key, valueDocument] of Object.entries(valueany.Documents)) {
            subElem = SubFliter(valueDocument, valueany.Name, "Documents", Section);
            if (subElem !== undefined) ra.push(subElem);
          }
        }
        if (valueany.Pages !== undefined) {
          for (const [key, valuePages] of Object.entries(valueany.Pages)) {
            subElem = SubFliter(valuePages, valueany.Name, "Pages", Section);
            if (subElem !== undefined) ra.push(subElem);
          }
        }
      }
      return ra;
    } else {
      return [];
    }
  }

  function SubFliter(json, PrevName, Who, Section) {
    let jsonReturn = {
      FullName: PrevName + "/" + json.Name,
      AfterName: "",
      Name: json.Name,
      Who: Who,
      PrevName: PrevName + "/",
      Section: Section,
    };
    switch (Who) {
      case "Documents":
        Object.assign(jsonReturn, { DocCfgID: json.DocCfgID });
      case "Report":
        Object.assign(jsonReturn, { ID: json.ID });
      case "Pages":
        Object.assign(jsonReturn, {
          ProgID: json.ProgID,
          Path: json.Path,
          CLSID: json.CLSID,
        });
    }
    return jsonReturn;
  }

  function ClearValue() {
    setValue("");
    setInputValue("");
    if (value === "") document.getElementById("MainSplitter").collapse(true);
  }

  return (
    <>
      <Autocomplete
        size="small"
        disableListWrap
        clearOnBlur
        handleHomeEndKeys
        sx={{
          display: "inline-block",
          width: "100%",
          ml: 1,
        }}
        value={value}
        onChange={(event, newValue) => {
          // (newValue)
          props.setSelected(newValue);
          setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        noOptionsText="Ничего не найдено :c"
        id="Search"
        options={SearhJson}
        // freeSolo
        PopperComponent={PopperMy}
        renderInput={(params) => (
          <div
            style={{
              backgroundColor: "white",
              border: "2px solid #eeeeee",
              paddingLeft: "5px",
            }}
            ref={params.InputProps.ref}
          >
            <input
              type={"text"}
              // style={{ width: "100%", height: "25px", borderRadius: "7px" }}
              style={{
                margin: "0",
                height: "100%",
                width: "100%",
                color: "#212529",
                border: "0",
                borderRadius: "0",
                outline: "none",
                padding: "0",
                fontSize: "13px",
                fontFamily: "Roboto",
                letterSpacing: "0px",
                backgroundColor: props.background ? "whitesmoke" : "inherit",
              }}
              placeholder="Поиск..."
              {...params.inputProps}
            />
          </div>
        )}
        renderOption={(props, option, { inputValue }) => {
          const text = option.PrevName + option.Name + option.AfterName;
          const matches = match(text, inputValue);
          const parts = parse(text, matches);

          return (
            <li {...props} key={`${props.key}_${props.id}`}>
              <div>
                {parts.map((part, index) => (
                  <span
                    key={index}
                    style={{
                      fontWeight: part.highlight ? 700 : 400,
                    }}
                  >
                    {part.text}
                  </span>
                ))}
              </div>
            </li>
          );
        }}
        getOptionLabel={(option) => option.FullName || ""}
      />
      <IconButton onClick={ClearValue}>
        <CloseIcon className={cn("iconButtonStimate", { light: theme === "light" })} fontSize="small" />
      </IconButton>
    </>
  );
}
